/* Overcomers Journal — global behavior: mobile nav drawer. */

class OjNavDrawer extends HTMLElement {
  connectedCallback() {
    this.openButton = this.querySelector('[data-oj-drawer-open]');
    this.closeButton = this.querySelector('[data-oj-drawer-close]');
    this.backdrop = this.querySelector('[data-oj-drawer-backdrop]');
    this.drawer = this.querySelector('[data-oj-drawer]');

    this.onKeydown = (event) => {
      if (event.key === 'Escape') this.close();
    };

    this.openButton?.addEventListener('click', () => this.open());
    this.closeButton?.addEventListener('click', () => this.close());
    this.backdrop?.addEventListener('click', () => this.close());
    this.querySelectorAll('[data-oj-drawer] a').forEach((link) => {
      link.addEventListener('click', () => this.close());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
    document.body.style.overflow = '';
  }

  open() {
    this.classList.add('is-open');
    this.openButton?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this.onKeydown);
    this.closeButton?.focus();
  }

  close() {
    this.classList.remove('is-open');
    this.openButton?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this.onKeydown);
  }
}

if (!customElements.get('oj-nav-drawer')) {
  customElements.define('oj-nav-drawer', OjNavDrawer);
}
